// extracted by mini-css-extract-plugin
module.exports = {"Hero":"Hero-module--Hero--1J6_N","HeroScroll":"Hero-module--HeroScroll--1kovu"};